import { createAsyncThunk } from '@reduxjs/toolkit';
import { TourBoasVindasService } from '../../common/services/boas-vindas';

export const verificaTourBoasVindas = createAsyncThunk(
  'tourBoasVindas/verificaTourBoasVindas',
  async (_, { rejectWithValue, getState }) => {
    try {
      const { matricula } = getState().user.data;

      if (!matricula) {
        return { Exibir: false, EtapaAtual: 0 };
      }

      const service = new TourBoasVindasService();
      const response = await service.getVerificaTourBoasVindas({ matricula });

      if (response.data && response.data[0]) {
        return response.data[0];
      }
      return { Exibir: false, EtapaAtual: 0 };
    } catch (error) {
      return rejectWithValue(`Ocorreu um erro ao verificar o Tour: ${error}`);
    }
  }
);

export const insereRegistroBoasVindas = createAsyncThunk(
  'tourBoasVindas/insereRegistroBoasVindas',
  async (etapa, { rejectWithValue, getState }) => {
    try {
      const { matricula } = getState().user.data;

      if (!matricula) {
        return rejectWithValue(
          'Ocorreu um erro ao inserir registros no Tour: matricula nao disponivel'
        );
      }

      const service = new TourBoasVindasService();
      const response = await service.setInsereRegistroBoasVindas({
        matricula,
        etapa,
      });

      if (response.data && response.data[0]?.linhasafetadas !== 0) {
        return response.data[0].linhasafetadas;
      }

      return rejectWithValue(
        'Ocorreu um erro ao inserir registros no Tour: Linhas afetadas: 0'
      );
    } catch (error) {
      return rejectWithValue(
        `Ocorreu um erro ao inserir registros no Tour: ${error}`
      );
    }
  }
);
